class LoadMoreProducts extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".load-more__button");
    this.collection = Array.from(
      document.querySelectorAll(
        `[data-collection="${this.button.dataset.collectionId}"] product-item-variant-selector`
      )
    );
    this.collectionNodeContainer = document.querySelector(
      `[data-collection="${this.button.dataset.collectionId}"] .collection__products-container`
    );
    this.collectionNode = document.querySelector(
      `[data-collection="${this.button.dataset.collectionId}"] .featured-collection__products-container`
    );
    this.allProducts = this.collectionNode.querySelectorAll(
      "product-item-variant-selector"
    );
    this.productsCount = this.dataset.collectionSize;
    this.indexPage = 2;
    this.addListeners();
  }
  addListeners() {
    if (this.collection && this.button) {
      this.button.addEventListener("click", () => this.showItems());
    }
  }

  showItems() {
    this.page_size = this.collectionNodeContainer.getAttribute(
      "data-product-loaded"
    );
    this.allProducts.forEach((p, index) => {
      if (
        index + 1 > this.page_size &&
        index + 1 <= this.page_size * this.indexPage
      ) {
        p.style.display = "flex";
      }
    });
    this.hideButton();
    this.indexPage = this.indexPage + 1;
  }

  hideButton() {
    if (this.page_size * this.indexPage >= this.productsCount) {
      this.button.style.display = "none";
    }
  }
}

customElements.define("load-more-products", LoadMoreProducts);
